import { render, staticRenderFns } from "./FarmDetail.vue?vue&type=template&id=71ceb63d&scoped=true&"
import script from "./FarmDetail.vue?vue&type=script&lang=js&"
export * from "./FarmDetail.vue?vue&type=script&lang=js&"
import style0 from "./FarmDetail.vue?vue&type=style&index=0&id=71ceb63d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ceb63d",
  null
  
)

export default component.exports